<template>
    <el-dialog title="站点收煤信息发布" :visible="visible" :show="show" width="45%"     :close-on-click-modal="false"
               @close="close" custom-class="module-dialog">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
            <el-form-item label="站点名称" class="input" prop="stationId" >
                <el-select v-model="ruleForm.stationId" style="width:100%" @change="changeStation">
                    <el-option v-for="item in stationList" :label="item.orgName" :value="item.orgId+''" :key="item.orgId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="目标热值" class="input" prop="targetHots" >
                <el-input v-model.number="ruleForm.targetHots" placeholder="请输入.." clearable></el-input>
            </el-form-item>
            <el-form-item label="目标硫分" class="input" prop="targetLiufen" >
                <el-input-number v-model="ruleForm.targetLiufen" style="width:100%" :controls="false" placeholder="请输入.." clearable></el-input-number>
            </el-form-item>
            <el-form-item label="煤炭总价" class="input" prop="totalPrice" >
                <el-input-number v-model="ruleForm.totalPrice" style="width:100%" :controls="false" placeholder="请输入.." clearable></el-input-number>
            </el-form-item>
            <el-form-item label="主力煤源名称" class="input" prop="cocalName" >
                <el-input v-model="ruleForm.cocalName" placeholder="请输入.." clearable></el-input>
            </el-form-item>
            <el-form-item label="主力煤源热值" class="input" prop="cocalHots" >
                <el-input-number v-model="ruleForm.cocalHots" style="width:100%" :controls="false" placeholder="请输入.." clearable></el-input-number>
            </el-form-item>
            <el-form-item label="主力煤源硫分" class="input" prop="cocalLiufen" >
                <el-input-number v-model="ruleForm.cocalLiufen" style="width:100%" :controls="false" placeholder="请输入.." clearable></el-input-number>
            </el-form-item>
            <el-form-item label="主力煤源单价" class="input" prop="cocalPrice" >
                <el-input-number v-model="ruleForm.cocalPrice" style="width:100%" :controls="false" placeholder="请输入.." clearable></el-input-number>
            </el-form-item>
            <el-form-item label="主力煤源库存" class="input" prop="cocalConst" >
                <el-input v-model.number="ruleForm.cocalConst" style="width:100%" :controls="false" placeholder="请输入.." clearable></el-input>
            </el-form-item>

            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary"  @click="commit()">保存</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'addOrUpdate',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                    this.loadStationList();
                }
            },
            rowData(){
//                this.ruleForm = this.rowData;
                if (this.rowData.id) {
                    this.$http({
                        url: "stationMessage/info/"+this.rowData.id,
                        method: "get",
                    }).then(({data}) => {
                        if (data.data!=null){
                            this.ruleForm = data.data;
                        }
                    });
                }
            },
        },
        data(){
            return{
                updateBtn:true,
                visible:false,
                url:base.get().url,
                ruleForm:{
                    stationId: null,
                    targetHots: null,
                    targetLiufen: null,
                    totalPrice: null,
                    cocalName: null,
                    cocalHots: null,
                    cocalLiufen: null,
                    cocalPrice: null,
                    cocalConst: null
                },
                rules:{
                    stationId: [
                        { required: true, message: '请选择站点名称', trigger: 'change' }
                    ],
                    targetHots: [
                        { required: true, message: '请输入目标热值', trigger: 'blur' }
                    ],
                    targetLiufen: [
                        { required: true, message: '请输入目标硫分', trigger: 'blur' }
                    ],
                    totalPrice: [
                        { required: true, message: '请输入煤炭总价', trigger: 'blur' }
                    ],
                    cocalName: [
                        { required: true, message: '请输入主力煤源名称', trigger: 'blur' }
                    ],
                    cocalHots: [
                        { required: true, message: '请输入主力煤源热值', trigger: 'blur' }
                    ],
                    cocalLiufen: [
                        { required: true, message: '请输入主力煤源硫分', trigger: 'blur' }
                    ],
                    cocalPrice: [
                        { required: true, message: '请输入主力煤源单价', trigger: 'blur' }
                    ],
                    cocalConst: [
                        { required: true, message: '请输入主力煤源库存', trigger: 'blur' }
                    ]
                },
                stationList:[],
            }
        },
        methods:{
            close(){
                this.updateBtn = true;
                this.$refs['ruleForm'].resetFields();
                this.$emit("listenToChildEvent",false);
            },
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url:  this.ruleForm.id==''|| this.ruleForm.id==undefined?this.url+`stationMessage/`+"save":this.url+`stationMessage/`+"update",
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: "保存成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            },
            loadStationList(){
                let userId = this.$storage.get("userId");
                this.$http({
                    url: "/sysUserOrg/getZdListByUserId/"+userId,
                    method: "get",
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        this.stationList = data.zdList;
                    }
                });
            },
            changeStation(){
                this.stationList.forEach((item)=>{
                    if (item.orgId == this.ruleForm.stationId) {
                        this.ruleForm.stationName = item.orgName;
                    }
                });
            }
        }
    }
</script>
<style lang="scss">
    .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }

    .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
        font-size: 16px;
    }

    .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }

    .detail-form-content .el-form-item {
        margin-bottom: 20px;
    }

    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
        font-size: 14px;
    }

    .detail-form-content .el-form-item__content {
        line-height: normal;
    }

    .detail-form-content .el-input__inner {
        border-radius: 4px;
        border-color: #dcdfe6;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-input__inner:focus {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-select {
        width: 100%;
    }

    .detail-form-content .el-upload-list--picture-card .el-upload-list__item,
    .detail-form-content .el-upload--picture-card {
        width: 120px;
        height: 120px;
        line-height: 126px;
        border-radius: 6px;
        border: 1px dashed #c0ccda;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-upload--picture-card:hover {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-upload--picture-card i {
        font-size: 28px;
        color: #8c939d;
    }

    .detail-form-content .el-upload--picture-card:hover i {
        color: var(--publicMainColor);
    }

    .detail-form-content .el-input.is-disabled .el-input__inner {
        background-color: #f5f7fa;
        color: #909399;
        cursor: not-allowed;
    }

    .detail-form-content .form-footer {
        display: flex;
        justify-content: center;
        gap: 12px;
        padding-top: 16px;
        border-top: 1px solid #f0f0f0;
        margin-top: 8px;
    }

    .detail-form-content .form-footer .el-button {
        min-width: 100px;
        border-radius: 4px;
    }

    .detail-form-content .form-footer .el-button--primary {
        background-color: var(--publicMainColor);
        border-color: var(--publicMainColor);
    }

    .detail-form-content .form-footer .el-button--primary:hover {
        background-color: #2b5797;
        border-color: #2b5797;
    }

    .detail-form-content .form-footer .el-button--default:hover {
        color: var(--publicMainColor);
        border-color: rgba(58, 110, 165, 0.3);
        background-color: rgba(58, 110, 165, 0.06);
    }
</style>